// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap */
import moment from "moment"
import { Record } from "immutable"

import { DATE_FORMAT } from "../consts/date"
import { REQUIRE_PID } from "../consts/pendingRequests"
import type { Input } from "../consts/pendingRequests"

const PendingRequestRecord = Record({
  id: null,
  status: null,
  reason: null,
  created: null,
  fulfilled: null,
  note: null,
  // only on some reasons
  pid: null,
  passport: null,
})

class PendingRequest extends PendingRequestRecord {
  // @ts-expect-error: Flow to TS migration.
  constructor(input: Input = {}) {
    if (REQUIRE_PID.includes(input.reason) && !input.pid && !input.passport) {
      throw new Error(`PendingRequest: pid and passport are required with reason ${input.reason}`)
    }

    const formatted = { ...input } as const
    // @ts-expect-error: Flow to TS migration.
    formatted.created = moment(formatted.created * 1000).format(DATE_FORMAT)

    if (input.fulfilled && formatted.fulfilled) {
      // @ts-expect-error: Flow to TS migration.
      formatted.fulfilled = moment(formatted.fulfilled * 1000).format(DATE_FORMAT)
    }

    super(formatted)
  }
}

export default PendingRequest
